import type { CSSProperties } from "react";
import type { StyleValue } from "../../../BuilderUI/StyleValue.types";
import type { AlignmentOption } from "../ModifiedStyleAttributes/objectAlignment";

export const EMAIL_BUTTON_BASE_STYLES = {
  display: "inline-block",
  borderStyle: "solid",
  textDecoration: "none",
  textAlign: "center",
} as const;

export const EMAIL_BUTTON_SECTION_PROPS = {
  align: "center" as const,
  width: "100%",
};

export const getAlignmentOptions = (
  defaultValue: AlignmentOption = "center",
): StyleValue => ({
  type: "string",
  value: defaultValue,
});

export interface MarginValues {
  marginBottom: string;
  marginLeft: string;
  marginRight: string;
  marginTop: string;
}

export const convertMarginToPadding = (marginValues: MarginValues) => ({
  paddingTop: marginValues.marginTop,
  paddingBottom: marginValues.marginBottom,
  paddingLeft: marginValues.marginLeft,
  paddingRight: marginValues.marginRight,
});

const toCssValue = (value: unknown): string | null => {
  if (value == null) return null;
  if (typeof value === "number") return `${value}px`;
  if (typeof value === "string" && value.trim()) return value.trim();
  return null;
};

const isZero = (value: string): boolean => {
  const num = parseFloat(value);
  return !value.trim() || num === 0;
};

export const ensureSingleButtonBorder = (linkStyles: CSSProperties): void => {
  const borderStyle = toCssValue(linkStyles.borderStyle);
  const borderWidth =
    toCssValue(linkStyles.borderWidth) || toCssValue(linkStyles.borderTopWidth);

  if (!borderWidth || isZero(borderWidth) || borderStyle === "none") return;

  const borderColor =
    toCssValue(linkStyles.borderColor) ??
    toCssValue(linkStyles.color) ??
    "currentColor";

  Object.assign(linkStyles, {
    boxShadow: `inset 0 0 0 ${borderWidth} ${borderColor}`,
  });
};
